export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.5 6H21a3 3 0 013 3v10a3 3 0 01-3 3H3a3 3 0 01-3-3V9a3 3 0 013-3h2.5l.95-1.89A2 2 0 018.24 3h7.52a2 2 0 011.79 1.11L18.5 6zM9.222 18.157a5 5 0 105.556-8.313 5 5 0 00-5.556 8.313zm2.07-6.864A1 1 0 0112 11a3 3 0 013 3 1 1 0 01-2 0 1 1 0 00-1-1 1 1 0 01-.707-1.707z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 24 24"
  }
};